import { useEffect, useState, useCallback } from "react";

import { api_without_cancellation } from "../../../api/api";
import { getCaseId, getClientId } from "../../../Utils/helper";

export const useGetCounsels = () => {
  const [counsels, setCounsels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCounsels = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api_without_cancellation.get(
        `/api/counsels/${getClientId()}/${getCaseId()}/`
      );
      setCounsels(res.data ?? []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCounsels();
  }, [fetchCounsels]);

  return { counsels, loading, error, refetch: fetchCounsels };
};
